const $1b48f3a1cde97508$export$aaacef11acc9e4f6 = 48;
const $1b48f3a1cde97508$export$bc90872e265d166e = 10;
const $1b48f3a1cde97508$export$8da1753993efc39a = "99999";
const $1b48f3a1cde97508$export$c995b89fa785e28 = "99998";
const $1b48f3a1cde97508$export$da9e2c336eb0e98e = {
    id: "9346dc6c-f982-48ce-9e21-f6a334b367b3",
    text: "Manifest is a grid-based pinboard for note taking.\n\nSimply click and drag anywhere to create a memo and snap it to the grid. All memos can be moved, resized, deleted and are saved in your browser's local storage between sessions.\n\nTo toggle between dark and light modes you can press Alt + T.\n\nManifest is free and completely open-source, please consider donating. \n\nhttps://donate.stripe.com/cN23ggaU156agSYaEF \n\nIf you find a bug or have a suggestion feel free to file an issue on Github. \n\nhttps://github.com/jonathontoon/manifest/issues",
    position: {
        top: 50,
        left: 50
    },
    size: {
        width: 400,
        height: 380
    }
};



function $a35f0494989b5cc7$export$715f9d76bb8c1fea(a) {
    return window.confirm(a);
}
function $a35f0494989b5cc7$export$5aa524d86254b4f(a, b) {
    return window.localStorage.setItem(`${a}`, JSON.stringify(b));
}
function $a35f0494989b5cc7$export$93d719890ad66653(a) {
    return JSON.parse(window.localStorage.getItem(a));
}
function $a35f0494989b5cc7$export$195604d042fd3f87(a, b) {
    return b * Math.round(a / b);
}
function $a35f0494989b5cc7$export$9448a5ef7e8c831a(a, b) {
    let c = null;
    return a.top > b.top && (c = {
        edge: "top",
        offset: 0
    }), a.left > b.left && (c = {
        edge: "left",
        offset: 0
    }), a.top + a.height < b.top + b.height && (c = {
        edge: "bottom",
        offset: $a35f0494989b5cc7$export$195604d042fd3f87(a.height - b.height, (0, $1b48f3a1cde97508$export$bc90872e265d166e))
    }), a.left + a.width < b.left + b.width && (c = {
        edge: "right",
        offset: $a35f0494989b5cc7$export$195604d042fd3f87(a.width - b.width, (0, $1b48f3a1cde97508$export$bc90872e265d166e))
    }), c;
}
function $a35f0494989b5cc7$export$e73c8bd0f20705a() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(a) {
        var b = 0 | 16 * Math.random(), c = "x" === a ? b : 8 | 3 & b;
        return c.toString(16);
    });
}
function $a35f0494989b5cc7$export$c2afdfb236bcd32() {
    const a = document.getElementsByClassName("memo");
    for (const b of a){
        let a = b.style.zIndex;
        b.style.zIndex = --a;
    }
}



let $f48db1e812ae03dd$var$activeMemo, $f48db1e812ae03dd$var$main, $f48db1e812ae03dd$var$canvas, $f48db1e812ae03dd$var$board, $f48db1e812ae03dd$var$selection, $f48db1e812ae03dd$var$currentMouse, $f48db1e812ae03dd$var$currentSize, $f48db1e812ae03dd$var$theme = "light";
/*
  Generic Event Handlers
*/ function $f48db1e812ae03dd$var$onMouseDown(a) {
    a.target === $f48db1e812ae03dd$var$board ? $f48db1e812ae03dd$var$handleBoardDragStart(a) : "drag" === a.target.classList[0] ? $f48db1e812ae03dd$var$handleMemoDragStart(a) : "resize" === a.target.classList[0] && $f48db1e812ae03dd$var$handleMemoResizeStart(a);
}
/*
  Memo Functions and Handlers
*/ function $f48db1e812ae03dd$var$createMemo(a, b, c, d) {
    const e = document.createElement("div");
    e.setAttribute("data-id", a), e.classList.add("memo"), e.style.top = `${c.top}px`, e.style.left = `${c.left}px`, e.style.width = `${d.width}px`, e.style.height = `${d.height}px`, e.style.zIndex = (0, $1b48f3a1cde97508$export$c995b89fa785e28);
    const f = document.createElement("textarea");
    f.classList.add("input"), f.setAttribute("placeholder", "Add a short memo..."), f.setAttribute("autocomplete", !0), b && (f.value = b), f.addEventListener("focus", function(a) {
        a.target.classList.add("active"), (0, $a35f0494989b5cc7$export$c2afdfb236bcd32)(), $f48db1e812ae03dd$var$activeMemo = a.target.parentNode, $f48db1e812ae03dd$var$activeMemo.style.zIndex = (0, $1b48f3a1cde97508$export$c995b89fa785e28);
    }), f.addEventListener("blur", function(a) {
        a.target.classList.remove("active");
    }, {
        passive: !1,
        useCapture: !1
    }), f.addEventListener("input", function(b) {
        const c = (0, $a35f0494989b5cc7$export$93d719890ad66653)("manifest_memos");
        c[a] = {
            ...c[a],
            text: b.target.value
        }, (0, $a35f0494989b5cc7$export$5aa524d86254b4f)("manifest_memos", c);
    }, {
        passive: !1,
        useCapture: !1
    }), e.appendChild(f);
    const g = document.createElement("div");
    g.classList.add("drag"), g.addEventListener("mousedown", $f48db1e812ae03dd$var$onMouseDown), g.addEventListener("touchstart", $f48db1e812ae03dd$var$onMouseDown), e.appendChild(g);
    const h = document.createElement("div");
    h.classList.add("close"), h.innerHTML = "\u2013", h.addEventListener("mouseup", $f48db1e812ae03dd$var$handleMemoClose), h.addEventListener("touchend", $f48db1e812ae03dd$var$handleMemoClose), e.appendChild(h);
    const i = document.createElement("div");
    return i.classList.add("resize"), i.addEventListener("mousedown", $f48db1e812ae03dd$var$onMouseDown), i.addEventListener("touchstart", $f48db1e812ae03dd$var$onMouseDown), e.appendChild(i), e;
}
function $f48db1e812ae03dd$var$handleMemoDragStart(a) {
    if (1 === a.which || a.touches) {
        (0, $a35f0494989b5cc7$export$c2afdfb236bcd32)(), $f48db1e812ae03dd$var$activeMemo = a.target.parentNode, $f48db1e812ae03dd$var$activeMemo.classList.add("active"), $f48db1e812ae03dd$var$activeMemo.style.zIndex = (0, $1b48f3a1cde97508$export$c995b89fa785e28);
        const b = $f48db1e812ae03dd$var$activeMemo.querySelectorAll(".input")[0];
        b.blur(), a.target.style.backgroundColor = "var(--gray)", a.target.style.cursor = "grabbing", document.body.style.cursor = "grabbing";
        const c = a.touches && 0 < a.touches.length ? (0, $a35f0494989b5cc7$export$195604d042fd3f87)(a.touches[0].clientX, (0, $1b48f3a1cde97508$export$bc90872e265d166e)) : (0, $a35f0494989b5cc7$export$195604d042fd3f87)(a.clientX, (0, $1b48f3a1cde97508$export$bc90872e265d166e)), d = a.touches && 0 < a.touches.length ? (0, $a35f0494989b5cc7$export$195604d042fd3f87)(a.touches[0].clientY, (0, $1b48f3a1cde97508$export$bc90872e265d166e)) : (0, $a35f0494989b5cc7$export$195604d042fd3f87)(a.clientY, (0, $1b48f3a1cde97508$export$bc90872e265d166e));
        $f48db1e812ae03dd$var$currentMouse = {
            x: c,
            y: d
        }, document.addEventListener("mousemove", $f48db1e812ae03dd$var$handleMemoDragMove, {
            passive: !1,
            useCapture: !1
        }), document.addEventListener("touchmove", $f48db1e812ae03dd$var$handleMemoDragMove, {
            passive: !1,
            useCapture: !1
        }), document.addEventListener("mouseup", $f48db1e812ae03dd$var$handleMemoDragEnd, {
            passive: !1,
            useCapture: !1
        }), document.addEventListener("touchcancel", $f48db1e812ae03dd$var$handleMemoDragEnd, {
            passive: !1,
            useCapture: !1
        }), document.addEventListener("touchend", $f48db1e812ae03dd$var$handleMemoDragEnd, {
            passive: !1,
            useCapture: !1
        });
    }
}
function $f48db1e812ae03dd$var$handleMemoDragMove(a) {
    const b = $f48db1e812ae03dd$var$activeMemo.classList.contains("active");
    if (b) {
        const b = a.touches && 0 < a.touches.length ? (0, $a35f0494989b5cc7$export$195604d042fd3f87)(a.touches[0].clientX, (0, $1b48f3a1cde97508$export$bc90872e265d166e)) : (0, $a35f0494989b5cc7$export$195604d042fd3f87)(a.clientX, (0, $1b48f3a1cde97508$export$bc90872e265d166e)), c = a.touches && 0 < a.touches.length ? (0, $a35f0494989b5cc7$export$195604d042fd3f87)(a.touches[0].clientY, (0, $1b48f3a1cde97508$export$bc90872e265d166e)) : (0, $a35f0494989b5cc7$export$195604d042fd3f87)(a.clientY, (0, $1b48f3a1cde97508$export$bc90872e265d166e));
        $f48db1e812ae03dd$var$activeMemo.style.top = `${$f48db1e812ae03dd$var$activeMemo.offsetTop - ($f48db1e812ae03dd$var$currentMouse.y - c)}px`, $f48db1e812ae03dd$var$activeMemo.style.left = `${$f48db1e812ae03dd$var$activeMemo.offsetLeft - ($f48db1e812ae03dd$var$currentMouse.x - b)}px`, $f48db1e812ae03dd$var$currentMouse = {
            x: b,
            y: c
        };
    }
}
function $f48db1e812ae03dd$var$handleMemoDragEnd(a) {
    const b = (0, $a35f0494989b5cc7$export$9448a5ef7e8c831a)($f48db1e812ae03dd$var$board.getBoundingClientRect(), $f48db1e812ae03dd$var$activeMemo.getBoundingClientRect()), c = a.touches && 0 < a.touches.length ? (0, $a35f0494989b5cc7$export$195604d042fd3f87)(a.touches[0].clientX, (0, $1b48f3a1cde97508$export$bc90872e265d166e)) : (0, $a35f0494989b5cc7$export$195604d042fd3f87)(a.clientX, (0, $1b48f3a1cde97508$export$bc90872e265d166e)), d = a.touches && 0 < a.touches.length ? (0, $a35f0494989b5cc7$export$195604d042fd3f87)(a.touches[0].clientY, (0, $1b48f3a1cde97508$export$bc90872e265d166e)) : (0, $a35f0494989b5cc7$export$195604d042fd3f87)(a.clientY, (0, $1b48f3a1cde97508$export$bc90872e265d166e));
    let e = $f48db1e812ae03dd$var$activeMemo.offsetTop - ($f48db1e812ae03dd$var$currentMouse.y - d), f = $f48db1e812ae03dd$var$activeMemo.offsetLeft - ($f48db1e812ae03dd$var$currentMouse.x - c);
    b && ("top" === b.edge ? e = b.offset : "bottom" === b.edge ? e = b.offset : "left" === b.edge ? f = b.offset : "right" === b.edge && (f = b.offset)), $f48db1e812ae03dd$var$activeMemo.style.top = `${e}px`, $f48db1e812ae03dd$var$activeMemo.style.left = `${f}px`, $f48db1e812ae03dd$var$activeMemo.classList.remove("active");
    const g = $f48db1e812ae03dd$var$activeMemo.querySelectorAll(".drag")[0];
    g.style.cursor = "grab", g.style.backgroundColor = "transparent";
    const h = $f48db1e812ae03dd$var$activeMemo.querySelectorAll(".input")[0];
    h.focus();
    const i = $f48db1e812ae03dd$var$activeMemo.dataset.id, j = (0, $a35f0494989b5cc7$export$93d719890ad66653)("manifest_memos");
    j[i] = {
        ...j[i],
        position: {
            top: e,
            left: f
        }
    }, (0, $a35f0494989b5cc7$export$5aa524d86254b4f)("manifest_memos", j), document.body.style.cursor = null, $f48db1e812ae03dd$var$activeMemo = null, $f48db1e812ae03dd$var$currentMouse = null, document.removeEventListener("mousemove", $f48db1e812ae03dd$var$handleMemoDragMove), document.removeEventListener("touchmove", $f48db1e812ae03dd$var$handleMemoDragMove), document.removeEventListener("mouseup", $f48db1e812ae03dd$var$handleMemoDragEnd), document.removeEventListener("touchcancel", $f48db1e812ae03dd$var$handleMemoDragEnd), document.removeEventListener("touchend", $f48db1e812ae03dd$var$handleMemoDragEnd);
}
function $f48db1e812ae03dd$var$handleMemoClose(a) {
    if ((0, $a35f0494989b5cc7$export$715f9d76bb8c1fea)("Are you sure you want to remove this memo?")) {
        const b = a.target.parentNode.dataset.id, c = (0, $a35f0494989b5cc7$export$93d719890ad66653)("manifest_memos");
        delete c[b], (0, $a35f0494989b5cc7$export$5aa524d86254b4f)("manifest_memos", c), $f48db1e812ae03dd$var$board.removeChild(a.target.parentNode);
    }
}
function $f48db1e812ae03dd$var$handleMemoResizeStart(a) {
    if (1 === a.which || a.touches) {
        (0, $a35f0494989b5cc7$export$c2afdfb236bcd32)(), $f48db1e812ae03dd$var$activeMemo = a.target.parentNode, $f48db1e812ae03dd$var$activeMemo.classList.add("active"), $f48db1e812ae03dd$var$activeMemo.style.zIndex = (0, $1b48f3a1cde97508$export$c995b89fa785e28);
        const b = $f48db1e812ae03dd$var$activeMemo.querySelectorAll(".input")[0];
        b.blur(), document.body.style.cursor = "nw-resize", a.target.style.backgroundColor = "var(--gray)";
        const c = a.touches && 0 < a.touches.length ? (0, $a35f0494989b5cc7$export$195604d042fd3f87)(a.touches[0].clientX, (0, $1b48f3a1cde97508$export$bc90872e265d166e)) : (0, $a35f0494989b5cc7$export$195604d042fd3f87)(a.clientX, (0, $1b48f3a1cde97508$export$bc90872e265d166e)), d = a.touches && 0 < a.touches.length ? (0, $a35f0494989b5cc7$export$195604d042fd3f87)(a.touches[0].clientY, (0, $1b48f3a1cde97508$export$bc90872e265d166e)) : (0, $a35f0494989b5cc7$export$195604d042fd3f87)(a.clientY, (0, $1b48f3a1cde97508$export$bc90872e265d166e)), e = $f48db1e812ae03dd$var$activeMemo.getBoundingClientRect(), f = parseInt(e.width, 10), g = parseInt(e.height, 10);
        $f48db1e812ae03dd$var$currentMouse = {
            x: c,
            y: d
        }, $f48db1e812ae03dd$var$currentSize = {
            width: f,
            height: g
        }, document.addEventListener("mousemove", $f48db1e812ae03dd$var$handleMemoResizeMove, {
            passive: !1,
            useCapture: !1
        }), document.addEventListener("touchmove", $f48db1e812ae03dd$var$handleMemoResizeMove, {
            passive: !1,
            useCapture: !1
        }), document.addEventListener("mouseup", $f48db1e812ae03dd$var$handleMemoResizeEnd, {
            passive: !1,
            useCapture: !1
        }), document.addEventListener("touchcancel", $f48db1e812ae03dd$var$handleMemoResizeEnd, {
            passive: !1,
            useCapture: !1
        }), document.addEventListener("touchend", $f48db1e812ae03dd$var$handleMemoResizeEnd, {
            passive: !1,
            useCapture: !1
        });
    }
}
function $f48db1e812ae03dd$var$handleMemoResizeMove(a) {
    const b = $f48db1e812ae03dd$var$activeMemo.classList.contains("active");
    if (b) {
        const b = a.touches && 0 < a.touches.length ? (0, $a35f0494989b5cc7$export$195604d042fd3f87)(a.touches[0].clientX, (0, $1b48f3a1cde97508$export$bc90872e265d166e)) : (0, $a35f0494989b5cc7$export$195604d042fd3f87)(a.clientX, (0, $1b48f3a1cde97508$export$bc90872e265d166e)), c = a.touches && 0 < a.touches.length ? (0, $a35f0494989b5cc7$export$195604d042fd3f87)(a.touches[0].clientY, (0, $1b48f3a1cde97508$export$bc90872e265d166e)) : (0, $a35f0494989b5cc7$export$195604d042fd3f87)(a.clientY, (0, $1b48f3a1cde97508$export$bc90872e265d166e)), d = $f48db1e812ae03dd$var$currentSize.width + (b - $f48db1e812ae03dd$var$currentMouse.x) - 2, e = $f48db1e812ae03dd$var$currentSize.height + (c - $f48db1e812ae03dd$var$currentMouse.y) - 2;
        $f48db1e812ae03dd$var$activeMemo.style.width = `${d}px`, $f48db1e812ae03dd$var$activeMemo.style.height = `${e}px`;
    }
}
function $f48db1e812ae03dd$var$handleMemoResizeEnd(a) {
    const b = a.touches && 0 < a.touches.length ? (0, $a35f0494989b5cc7$export$195604d042fd3f87)(a.touches[0].clientX, (0, $1b48f3a1cde97508$export$bc90872e265d166e)) : (0, $a35f0494989b5cc7$export$195604d042fd3f87)(a.clientX, (0, $1b48f3a1cde97508$export$bc90872e265d166e)), c = a.touches && 0 < a.touches.length ? (0, $a35f0494989b5cc7$export$195604d042fd3f87)(a.touches[0].clientY, (0, $1b48f3a1cde97508$export$bc90872e265d166e)) : (0, $a35f0494989b5cc7$export$195604d042fd3f87)(a.clientY, (0, $1b48f3a1cde97508$export$bc90872e265d166e)), d = $f48db1e812ae03dd$var$currentSize.width + (b - $f48db1e812ae03dd$var$currentMouse.x) - 2, e = $f48db1e812ae03dd$var$currentSize.height + (c - $f48db1e812ae03dd$var$currentMouse.y) - 2;
    $f48db1e812ae03dd$var$activeMemo.style.width = `${d}px`, $f48db1e812ae03dd$var$activeMemo.style.height = `${e}px`;
    const f = (0, $a35f0494989b5cc7$export$9448a5ef7e8c831a)($f48db1e812ae03dd$var$board.getBoundingClientRect(), $f48db1e812ae03dd$var$activeMemo.getBoundingClientRect());
    if (f) {
        let a = $f48db1e812ae03dd$var$activeMemo.offsetTop, b = $f48db1e812ae03dd$var$activeMemo.offsetLeft;
        "top" === f.edge ? a = f.offset : "bottom" === f.edge ? a = f.offset : "left" === f.edge ? b = f.offset : "right" === f.edge && (b = f.offset), $f48db1e812ae03dd$var$activeMemo.style.top = `${a}px`, $f48db1e812ae03dd$var$activeMemo.style.left = `${b}px`;
    }
    const g = $f48db1e812ae03dd$var$activeMemo.querySelectorAll(".resize")[0];
    g.style.cursor = "nw-resize", g.style.backgroundColor = "transparent", $f48db1e812ae03dd$var$activeMemo.classList.remove("active");
    const h = $f48db1e812ae03dd$var$activeMemo.querySelectorAll(".input")[0];
    h.focus();
    const i = $f48db1e812ae03dd$var$activeMemo.dataset.id, j = (0, $a35f0494989b5cc7$export$93d719890ad66653)("manifest_memos");
    j[i] = {
        ...j[i],
        size: {
            width: d,
            height: e
        }
    }, (0, $a35f0494989b5cc7$export$5aa524d86254b4f)("manifest_memos", j), document.body.style.cursor = null, $f48db1e812ae03dd$var$activeMemo = null, $f48db1e812ae03dd$var$currentSize = null, document.removeEventListener("mousemove", $f48db1e812ae03dd$var$handleMemoResizeMove, {
        passive: !1,
        useCapture: !1
    }), document.removeEventListener("touchmove", $f48db1e812ae03dd$var$handleMemoResizeMove, {
        passive: !1,
        useCapture: !1
    }), document.removeEventListener("mouseup", $f48db1e812ae03dd$var$handleMemoResizeEnd, {
        passive: !1,
        useCapture: !1
    }), document.removeEventListener("touchcancel", $f48db1e812ae03dd$var$handleMemoResizeEnd, {
        passive: !1,
        useCapture: !1
    }), document.removeEventListener("touchend", $f48db1e812ae03dd$var$handleMemoResizeEnd, {
        passive: !1,
        useCapture: !1
    });
}
/*
  Board Functions and Handlers
*/ function $f48db1e812ae03dd$var$handleBoardDragStart(a) {
    if (1 === a.which || a.touches) {
        document.body.style.cursor = "crosshair", $f48db1e812ae03dd$var$board.classList.add("active");
        const b = $f48db1e812ae03dd$var$board.getBoundingClientRect(), c = a.touches && 0 < a.touches.length ? (0, $a35f0494989b5cc7$export$195604d042fd3f87)(a.touches[0].clientX - b.left, (0, $1b48f3a1cde97508$export$bc90872e265d166e)) : (0, $a35f0494989b5cc7$export$195604d042fd3f87)(a.clientX - b.left, (0, $1b48f3a1cde97508$export$bc90872e265d166e)), d = a.touches && 0 < a.touches.length ? (0, $a35f0494989b5cc7$export$195604d042fd3f87)(a.touches[0].clientY - b.top, (0, $1b48f3a1cde97508$export$bc90872e265d166e)) : (0, $a35f0494989b5cc7$export$195604d042fd3f87)(a.clientY - b.top, (0, $1b48f3a1cde97508$export$bc90872e265d166e));
        $f48db1e812ae03dd$var$currentMouse = {
            x: c,
            y: d
        }, $f48db1e812ae03dd$var$selection = document.createElement("div"), $f48db1e812ae03dd$var$selection.setAttribute("id", "selection"), $f48db1e812ae03dd$var$selection.style.zIndex = (0, $1b48f3a1cde97508$export$8da1753993efc39a), $f48db1e812ae03dd$var$board.appendChild($f48db1e812ae03dd$var$selection), document.addEventListener("mousemove", $f48db1e812ae03dd$var$handleBoardDragMove), document.addEventListener("touchmove", $f48db1e812ae03dd$var$handleBoardDragMove), document.addEventListener("mouseup", $f48db1e812ae03dd$var$handleBoardDragEnd), document.addEventListener("touchcancel", $f48db1e812ae03dd$var$handleBoardDragEnd), document.addEventListener("touchend", $f48db1e812ae03dd$var$handleBoardDragEnd);
    }
}
function $f48db1e812ae03dd$var$handleBoardDragMove(a) {
    const b = $f48db1e812ae03dd$var$board.getBoundingClientRect(), c = a.touches && 0 < a.touches.length ? (0, $a35f0494989b5cc7$export$195604d042fd3f87)(a.touches[0].clientX - b.left, (0, $1b48f3a1cde97508$export$bc90872e265d166e)) : (0, $a35f0494989b5cc7$export$195604d042fd3f87)(a.clientX - b.left, (0, $1b48f3a1cde97508$export$bc90872e265d166e)), d = a.touches && 0 < a.touches.length ? (0, $a35f0494989b5cc7$export$195604d042fd3f87)(a.touches[0].clientY - b.top, (0, $1b48f3a1cde97508$export$bc90872e265d166e)) : (0, $a35f0494989b5cc7$export$195604d042fd3f87)(a.clientY - b.top, (0, $1b48f3a1cde97508$export$bc90872e265d166e)), e = 0 > d - $f48db1e812ae03dd$var$currentMouse.y ? d : $f48db1e812ae03dd$var$currentMouse.y, f = 0 > c - $f48db1e812ae03dd$var$currentMouse.x ? c : $f48db1e812ae03dd$var$currentMouse.x, g = Math.abs(c - $f48db1e812ae03dd$var$currentMouse.x) + 1, h = Math.abs(d - $f48db1e812ae03dd$var$currentMouse.y) + 1;
    $f48db1e812ae03dd$var$selection.style.top = `${e}px`, $f48db1e812ae03dd$var$selection.style.left = `${f}px`, $f48db1e812ae03dd$var$selection.style.width = `${g}px`, $f48db1e812ae03dd$var$selection.style.height = `${h}px`;
}
function $f48db1e812ae03dd$var$handleBoardDragEnd() {
    const a = $f48db1e812ae03dd$var$board.getBoundingClientRect(), b = $f48db1e812ae03dd$var$selection.getBoundingClientRect(), c = b.width - 2, d = b.height - 2;
    let e = b.top - a.top, f = b.left - a.left;
    const g = (0, $a35f0494989b5cc7$export$9448a5ef7e8c831a)(a, b);
    if (g && ("top" === g.edge ? e = g.offset : "bottom" === g.edge ? e = g.offset : "left" === g.edge ? f = g.offset : "right" === g.edge && (f = g.offset)), 80 <= c && 80 <= d) {
        const a = (0, $a35f0494989b5cc7$export$e73c8bd0f20705a)(), b = $f48db1e812ae03dd$var$createMemo(a, null, {
            top: e,
            left: f
        }, {
            width: c,
            height: d
        });
        $f48db1e812ae03dd$var$board.appendChild(b);
        const g = b.querySelectorAll(".input")[0];
        g.focus();
        const h = (0, $a35f0494989b5cc7$export$93d719890ad66653)("manifest_memos");
        h[a] = {
            text: null,
            position: {
                top: e,
                left: f
            },
            size: {
                width: c,
                height: d
            }
        }, (0, $a35f0494989b5cc7$export$5aa524d86254b4f)("manifest_memos", h), $f48db1e812ae03dd$var$activeMemo = b;
    }
    document.body.style.cursor = null, $f48db1e812ae03dd$var$board.classList.remove("active"), $f48db1e812ae03dd$var$board.removeChild($f48db1e812ae03dd$var$selection), document.removeEventListener("mousemove", $f48db1e812ae03dd$var$handleBoardDragMove, {
        passive: !1,
        useCapture: !1
    }), document.removeEventListener("touchmove", $f48db1e812ae03dd$var$handleBoardDragMove, {
        passive: !1,
        useCapture: !1
    }), document.removeEventListener("mouseup", $f48db1e812ae03dd$var$handleBoardDragEnd, {
        passive: !1,
        useCapture: !1
    }), document.removeEventListener("touchcancel", $f48db1e812ae03dd$var$handleBoardDragEnd, {
        passive: !1,
        useCapture: !1
    }), document.removeEventListener("touchend", $f48db1e812ae03dd$var$handleBoardDragEnd, {
        passive: !1,
        useCapture: !1
    });
}
/*
  App Functions
*/ function $f48db1e812ae03dd$var$toggleTheme() {
    const a = document.querySelector("body");
    // Redraw the canvas
    "light" === $f48db1e812ae03dd$var$theme ? (a.classList.add("dark"), $f48db1e812ae03dd$var$theme = "dark", (0, $a35f0494989b5cc7$export$5aa524d86254b4f)("manifest_theme", "dark")) : (a.classList.remove("dark"), $f48db1e812ae03dd$var$theme = "light", (0, $a35f0494989b5cc7$export$5aa524d86254b4f)("manifest_theme", "light")), $f48db1e812ae03dd$var$onResize();
}
function $f48db1e812ae03dd$var$handleTheme() {
    const a = document.querySelector("body"), b = (0, $a35f0494989b5cc7$export$93d719890ad66653)("manifest_theme");
    // Prefer saved preference over OS preference
    return b ? void ("dark" === b ? (a.classList.add("dark"), $f48db1e812ae03dd$var$theme = "dark", (0, $a35f0494989b5cc7$export$5aa524d86254b4f)("manifest_theme", "dark")) : (a.classList.remove("dark"), $f48db1e812ae03dd$var$theme = "light", (0, $a35f0494989b5cc7$export$5aa524d86254b4f)("manifest_theme", "light"))) : void (window.matchMedia("(prefers-color-scheme: dark)").matches && (a.classList.add("dark"), $f48db1e812ae03dd$var$theme = "dark"));
}
function $f48db1e812ae03dd$var$onKeydown(a) {
    ("KeyT" === a.code || 84 === a.keyCode) && a.altKey && $f48db1e812ae03dd$var$toggleTheme();
}
function $f48db1e812ae03dd$var$onResize() {
    $f48db1e812ae03dd$var$main.style.width = `${window.innerWidth}px`, $f48db1e812ae03dd$var$main.style.height = `${window.innerHeight}px`;
    const a = window.innerWidth - (0, $1b48f3a1cde97508$export$aaacef11acc9e4f6) - 1, b = window.innerHeight - (0, $1b48f3a1cde97508$export$aaacef11acc9e4f6) + 1;
    $f48db1e812ae03dd$var$canvas.setAttribute("width", a), $f48db1e812ae03dd$var$canvas.setAttribute("height", b), $f48db1e812ae03dd$var$canvas.style.top = `${(0, $1b48f3a1cde97508$export$aaacef11acc9e4f6) / 2}px`, $f48db1e812ae03dd$var$canvas.style.left = `${(0, $1b48f3a1cde97508$export$aaacef11acc9e4f6) / 2}px`, $f48db1e812ae03dd$var$canvas.style.width = `${a}px`, $f48db1e812ae03dd$var$canvas.style.height = `${b}px`;
    const c = $f48db1e812ae03dd$var$canvas.getContext("2d");
    for(let d = 0; d <= a; d += (0, $1b48f3a1cde97508$export$bc90872e265d166e))for(let a = 0; a <= b; a += (0, $1b48f3a1cde97508$export$bc90872e265d166e))c.fillStyle = "light" === $f48db1e812ae03dd$var$theme ? "rgba(0, 0, 0, 0.5)" : "rgba(255, 255, 255, 0.4)", c.beginPath(), c.rect(d, a, 1, 1), c.fill();
    $f48db1e812ae03dd$var$board.style.top = `${(0, $1b48f3a1cde97508$export$aaacef11acc9e4f6) / 2}px`, $f48db1e812ae03dd$var$board.style.left = `${(0, $1b48f3a1cde97508$export$aaacef11acc9e4f6) / 2}px`, $f48db1e812ae03dd$var$board.style.width = `${a}px`, $f48db1e812ae03dd$var$board.style.height = `${b}px`, $f48db1e812ae03dd$var$currentMouse = null, $f48db1e812ae03dd$var$currentSize = null;
}
function $f48db1e812ae03dd$var$onLoad() {
    $f48db1e812ae03dd$var$handleTheme(), $f48db1e812ae03dd$var$main = document.createElement("main"), $f48db1e812ae03dd$var$main.setAttribute("id", "app"), $f48db1e812ae03dd$var$canvas = document.createElement("canvas"), $f48db1e812ae03dd$var$canvas.setAttribute("id", "grid"), $f48db1e812ae03dd$var$board = document.createElement("section"), $f48db1e812ae03dd$var$board.setAttribute("id", "board"), $f48db1e812ae03dd$var$board.addEventListener("mousedown", $f48db1e812ae03dd$var$onMouseDown, {
        passive: !1,
        useCapture: !1
    }), $f48db1e812ae03dd$var$board.addEventListener("touchstart", $f48db1e812ae03dd$var$onMouseDown, {
        passive: !1,
        useCapture: !1
    }), $f48db1e812ae03dd$var$main.appendChild($f48db1e812ae03dd$var$canvas), $f48db1e812ae03dd$var$main.appendChild($f48db1e812ae03dd$var$board), document.body.appendChild($f48db1e812ae03dd$var$main), document.body.addEventListener("touchmove", function(a) {
        a.preventDefault();
    }, {
        passive: !1,
        useCapture: !1
    });
    const a = (0, $a35f0494989b5cc7$export$93d719890ad66653)("manifest_memos");
    if (!a || 0 === Object.keys(a).length) {
        const a = $f48db1e812ae03dd$var$createMemo((0, $1b48f3a1cde97508$export$da9e2c336eb0e98e).id, (0, $1b48f3a1cde97508$export$da9e2c336eb0e98e).text, (0, $1b48f3a1cde97508$export$da9e2c336eb0e98e).position, (0, $1b48f3a1cde97508$export$da9e2c336eb0e98e).size);
        $f48db1e812ae03dd$var$board.appendChild(a);
        const b = {};
        b[(0, $1b48f3a1cde97508$export$da9e2c336eb0e98e).id] = {
            text: (0, $1b48f3a1cde97508$export$da9e2c336eb0e98e).text,
            position: (0, $1b48f3a1cde97508$export$da9e2c336eb0e98e).position,
            size: (0, $1b48f3a1cde97508$export$da9e2c336eb0e98e).size
        }, (0, $a35f0494989b5cc7$export$5aa524d86254b4f)("manifest_memos", b);
    } else for (const b of Object.keys(a)){
        const c = $f48db1e812ae03dd$var$createMemo(b, a[b].text, a[b].position, a[b].size);
        $f48db1e812ae03dd$var$board.appendChild(c);
    }
    $f48db1e812ae03dd$var$onResize();
}
window.addEventListener("resize", $f48db1e812ae03dd$var$onResize), window.addEventListener("load", $f48db1e812ae03dd$var$onLoad), window.addEventListener("keydown", $f48db1e812ae03dd$var$onKeydown);


//# sourceMappingURL=index.fad97902.js.map
